module.exports = __webpack_public_path__ + "static/media/rahul.448df952.jpeg";